export const RESET_CUSTOMER_LOYALTY_ISFETCHING =
  'RESET_CUSTOMER_LOYALTY_ISFETCHING';
export const LIST_CUSTOMER_LOYALTY_REQUEST = 'LIST_CUSTOMER_LOYALTY_REQUEST';
export const LIST_CUSTOMER_LOYALTY_SUCCESS = 'LIST_CUSTOMER_LOYALTY_SUCCESS';
export const CUSTOMER_LOYALTY_LIST_REQUESTING =
  'CUSTOMER_LOYALTY_LIST_REQUESTING';
